

































































































































































import Vue from "vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import DataTable, { Header as THeader, Options } from "@/components/table";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";
import { Element } from "@/types";
import AlertService from "@/services/libs/AlertService";
import Multiselect from "@/components/ui/Multiselect.vue";

interface Action {
  icon: String;
  f: Function;
  title: String;
  type: String;
  public: Boolean;
}

interface Header extends THeader {
  /** type for detail edit field */
  type?: String;
  /** options for select and multiselect */
  options?: Array<Element>;
  getOptions?: Function;
  /** show only on detail edit not in table */
  detailonly?: boolean;
  /** show only in table not in detail edit */
  readonly?: boolean;
  /** placeholder when value is empty */
  placeholder?: String;
  /** set the required property for client validation */
  required?: boolean;
}
export { Header, Options, Action };

/**
 * @Emits delete event if the delete button is clicked
 * @Emits new event when new button is clicked
 * @Emits rowClick event if an row is clicked
 */
export default Vue.extend({
  name: "SmallTable",
  components: {
    Fieldset,
    DataTable,
    DeleteDialog,
    Multiselect,
  },
  props: {
    title: {
      type: String,
    },
    header: {
      type: Array as () => Array<Header>,
      required: true,
    },
    options: {
      type: Object as () => Options,
    },
    data: {
      type: Array as () => Array<any>,
      default: () => [],
    },
    actions: {
      type: Array as () => Array<Action>,
      default: () => [],
    },
    newButtonText: {
      type: String,
      required: true,
    },
    newElement: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    addOnNew: {
      type: Boolean,
      default: true,
    },
    onlyOneNewElement: {
      type: Boolean,
      default: false,
    },
    errorMessageOnOnlyOneNewElement: {
      type: String,
      default:
        "Das zuvor angelegte Element muss vollständig befüllt sein, bevor ein neues Element angelegt werden darf.",
    },
    deleteText: {
      type: String,
      default: "Dieses Element wirklich entfernen?",
    },
  },
  data: () => ({
    openDetailed: [] as number[],
    openDeleteDialog: false,
    deleteObject: undefined as any,
    lastNewElement: undefined as any,
    tableupdate: 0,
  }),
  computed: {
    tableHeader(): Array<Header> {
      if (!this.header) return [];
      return this.header.filter((h) => !h.detailonly);
    },
    detailHeader(): Array<Header> {
      if (!this.header) return [];
      return this.header.filter((h) => !h.readonly);
    },
    actionWidth(): string {
      var width = 0;
      this.actions.forEach((a) => (width += a.public ? 35 : 0));
      if (this.editable) width += 30;
      return width + "px";
    },
  },
  methods: {
    /** generate a number from -100 to 0 */
    createId(): number {
      return -Math.floor(Math.random() * 100);
    },
    onClick(row: any) {
      console.info("click..." + row.id);
      if (!this.showDetails) return;
      // only open one row at once
      if (this.openDetailed.length && this.openDetailed[0] != row.id)
        this.openDetailed = [row.id];
      // hide detail if dialog is open
      if (this.openDeleteDialog) this.openDetailed = [];
      // emit event
      this.$emit("rowClick", row);
    },
    validateTable(): boolean {
      if (this.lastNewElement === undefined) {
        return true;
      }
      for (const header of this.header) {
        if (
          header.required === true &&
          (this.lastNewElement[header.field] === undefined ||
            this.lastNewElement[header.field] === "" ||
            this.lastNewElement[header.field] === null)
        ) {
          AlertService.warning(this.errorMessageOnOnlyOneNewElement);
          return false;
        }
      }
      return true;
    },
    onNewClick() {
      let addingAllowed = true;
      if (this.onlyOneNewElement) {
        addingAllowed = this.validateTable();
      }
      if (addingAllowed) {
        const id = this.createId();
        const newElement = Object.assign({ id: id }, this.newElement);
        if (this.addOnNew) {
          this.data.unshift(newElement);
          this.openDetailed = [id];
        }
        this.lastNewElement = newElement;
        // emit event
        this.$emit("new", newElement);
      }
    },
    onDelete(row: any): void {
      this.deleteObject = row;
      this.openDeleteDialog = true;
    },
    rowClass(row: any, index: number): String {
      if (row.__dataObject.del !== undefined && row.__dataObject.del)
        return "is-deleting ";
      return "";
    },
    onDeleteConfirm() {
      let id = this.deleteObject.id;
      if (id === undefined) return;

      if (id < 0) {
        this.data.forEach((item, index) => {
          if (item.id === id) this.data.splice(index, 1);
        });
      } else {
        this.data.forEach(function (val: any) {
          if (val.id == id) {
            console.info("newclick " + id);
            val.del = true;
          }
        });
      }
      // emit event
      this.$emit("delete", this.deleteObject);
      this.deleteObject = undefined;
      //this.tableupdate++;
    },
  },
});
